export default "__VITE_ASSET__347ddf8c__"